//react component
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Helmet } from "react-helmet";
import { isMobileDevice } from "../../../utils/utils";
import { Route, Routes, useLocation } from "react-router-dom";
import TmdbListIndex from "../movies/tmdbListIndex";
import MovieDetails from "../movies/movieDetails/movieDetails";
import SerieDetails from "../movies/serieDetails/serieDetails";
import EpisodeDetails from "../movies/episodeDetails/episodeDetails";
import { useSelector } from "react-redux";
import users from "../../users";
import SquadflixHome from "../squadflixHome/squadflixHome";
import TorrentsDashboard from "../torrentsDashboard/torrentsDashboard";
import LiveChannelDetails from "../movies/liveChannelDetails/liveChannelDetails";
import LiveCustomLinks from "../movies/liveCustomLinks/liveCustomLinks";
import { useChatStore } from "../../chatbot/store/chatbotStore";
import SquadflixDeviceLinker from "../squadflix-device-linker/squadflix-device-linker";
import Cap17driveSearcher from '../cap17driveSearcher/cap17driveSearcher';
import Cap17driveHeader from "./cap17driveHeader/cap17driveHeader";
import LiveEventDetails from "../movies/liveEventDetails/liveEventDetails";
import { TowersSportsApi } from "../../../apis/towers-sports-api/towers-sports-api";
import { SquadflixLiveChannelDetails } from "../squadflixLive/squadflixLiveChannelDetails/squadflixLiveChannelDetails";
import { SquadflixLiveStream } from "../squadflixLive/squadflixLiveStream/squadflixLiveStream";
import UseScrollContainerRef from '../movies/utils/useScrollContainerRef';
import useUserPreferences from "../../user-app-config/hooks/use-user-preferences";
import SquadflixTvIndex from "../squadflixTvTab/SquadflixTvIndex";

function Cap17driveIndex({ squadflixTvHook }) {
    const [acestreamLinks, setAcestreamLinks] = useState([]);
    const darkMode = useSelector(users.selectors.isDarkMode);
    const { userPreferences } = useUserPreferences();
    const [navWidth, setNavWidth] = useState(0);
    const [scrollPadding, setScrollPadding] = useState(0);
    const groupContainer = useRef(document.getElementById('moviesContainer'));
    const scrollContainer = useRef(document.getElementById('home__scrollContainer'));
    const parentRef = UseScrollContainerRef();
    const location = useLocation();
    const {
        hasPermission
    } = useChatStore();

    const handleResize = () => {
        if (!groupContainer.current) {
            groupContainer.current = document.getElementById('moviesContainer');
        }
        if (!scrollContainer.current) {
            scrollContainer.current = document.getElementById('home__scrollContainer');
        }
        if (groupContainer.current) {
            setNavWidth(groupContainer.current.clientWidth);
        }
        if (scrollContainer.current) {
            setScrollPadding(scrollContainer.current.clientWidth - groupContainer.current.clientWidth);
        }
    };

    console.log("Render Cap17driveIndex", { navWidth, scrollPadding });

    useEffect(() => {

        window.addEventListener('resize', handleResize)
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const showNav = useMemo(() => {
        const navRoutes = ["/squadflix/series", "/squadflix/movies", "/squadflix/search-tmdb", "/squadflix/notes", "/squadflix/home", "/squadflix/live", "/squadflix/link", "/squadflix/devices", "/squadflix"];
        return navRoutes.some(x => x === location.pathname || (x + "/") === location.pathname);
    }, [location]);

    const isSmallNav = useMemo(() => {
        const navRoutes = ["/squadflix/notes", "/squadflix/search-tmdb", "/squadflix/home", "/squadflix/live", "/squadflix/link", "/squadflix/devices", "/squadflix"];
        return navRoutes.some(x => x === location.pathname || (x + "/") === location.pathname);
    }, [location]);

    const updateNavWidth = () => {
        if (groupContainer) {
            requestAnimationFrame(() => {
                if (!groupContainer.current) {
                    groupContainer.current = document.getElementById('moviesContainer');
                }
                setNavWidth(groupContainer.current.clientWidth);
                if (!scrollContainer.current) {
                    scrollContainer.current = document.getElementById('home__scrollContainer');
                }
                setScrollPadding(scrollContainer.current.clientWidth - groupContainer.current.clientWidth);
            });
        }
    }

    useEffect(() => {
        const getLinks = async (intent = 0) => {
            TowersSportsApi.getAcestreamLinks().then(links => {
                if (links?.length > 0) {
                    setAcestreamLinks(links);
                } else {
                    if (intent === 0) {
                        setTimeout(() => {
                            getLinks(1);
                        }, 1000);
                        return;
                    }
                    setAcestreamLinks([{
                        name: "No se han encontrado links",
                        id: "no-links",
                    }]);
                }
                updateNavWidth();
            })
                .catch(error => console.error('Error fetching links:', error));
        }

        getLinks();
    }, []);

    if (userPreferences?.tvMode) {
        return (
            <div id="moviesContainer">
                <SquadflixTvIndex
                    squadflixTvHook={squadflixTvHook}
                    acestreamLinks={acestreamLinks}
                    onWidthChange={updateNavWidth}
                />
            </div>
        );
    }

    return (
        <div id="moviesContainer">
            <Helmet>
                <meta charSet="utf-8" />
                <title>SquadFlix</title>
            </Helmet>
            {showNav && <>
                <div style={{
                    top: 0,
                    width: parentRef.width,
                    position: "fixed",
                    backgroundColor: (darkMode ? "#212529" : "white"),
                    zIndex: 2,
                    height: (isMobileDevice() ? 133.2 : 146) - (isSmallNav ? 73 : 0),
                    padding: "0 -5px",
                    borderBottomRightRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    transform: `translateX(-${scrollPadding / 2}px)`,
                }}>

                </div>
                <div style={{
                    position: "sticky",
                    width: "100%",
                    top: 2,
                    zIndex: 3,
                    paddingBottom: "30px"
                }}>
                    <Cap17driveHeader squadflixTvHook={squadflixTvHook} />
                </div>
            </>}

            <div>
                <Routes>
                    <Route path="/" element={<SquadflixHome onWidthChange={updateNavWidth} />} />
                    <Route path="/link" element={<SquadflixDeviceLinker />} />
                    <Route path="/home" element={<SquadflixHome onWidthChange={updateNavWidth} />} />
                    <Route path="/search-tmdb" element={<Cap17driveSearcher hideTitle onlyResults={!isMobileDevice()}
                        showTmdbVotes={true}
                        className={"cap17driveSearcher-fullview"} />} />
                    <Route path="/live"
                        element={<TmdbListIndex acestreamLinks={acestreamLinks} onWidthChange={updateNavWidth}
                            type="live" />} />
                    <Route path="/movies/:id/*" element={<MovieDetails squadflixTvHook={squadflixTvHook} />} />
                    <Route path="/series/:id" element={<SerieDetails squadflixTvHook={squadflixTvHook} />} />
                    <Route path="/live/custom" element={<LiveCustomLinks />} />
                    <Route path="/live/custom/play/:id"
                        element={<LiveChannelDetails />} />
                    <Route path="/live/channel/:id" element={<SquadflixLiveChannelDetails />} />
                    <Route path="/live/channel/:channelId/stream/:streamId" element={<SquadflixLiveStream />} />
                    <Route path="/live/:id" element={<LiveChannelDetails acestreamLinks={acestreamLinks} />} />
                    <Route path="/live-event/:eventId/:option" element={<LiveEventDetails />} />
                    <Route path="/series/:serieId/:seasonNumber/:episodeNumber"
                        element={<EpisodeDetails squadflixTvHook={squadflixTvHook} />} />
                    {hasPermission("towersstreamDashboard") &&
                        <Route path="/towersstream/dash"
                            element={<TorrentsDashboard onWidthChange={updateNavWidth} />} />}
                </Routes>
            </div>


        </div>
    )
}

export default Cap17driveIndex;
